import { combineReducers, createRequestReducer } from '@fullstory/redux-util';
import { InstantInsightActions, MetricsInsightsRequestActions } from './actions';
import {
  GetInsightDetailViewResp,
  InsightRequestTypes,
  InsightsById,
  MetricInsightState,
} from './types';

const insightDetailViewResponse = createRequestReducer<GetInsightDetailViewResp>()(
  InsightRequestTypes.GetInsightDetailViewRequest,
  InsightRequestTypes.GetInsightDetailViewSuccess,
  InsightRequestTypes.GetInsightDetailViewFailure,
);

function metricInsights(
  state: MetricInsightState = {},
  action: MetricsInsightsRequestActions,
): MetricInsightState {
  switch (action.type) {
    case InsightRequestTypes.GetInsightsSuccess:
    case InsightRequestTypes.GetInsightDetailViewSuccess: {
      return action.data.insights.reduce<InsightsById>(
        (acc, val) => {
          acc[val.insightId] = val;
          return acc;
        },
        { ...state },
      );
    }
  }
  return state;
}

function checkedForInsights(
  state: Set<number> = new Set<number>(),
  action: InstantInsightActions,
): Set<number> {
  switch (action.type) {
    case InsightRequestTypes.AddCheckedForInsightsHash: {
      if (action.dxIdVersionHash) {
        const newSet = new Set(state);
        newSet.add(action.dxIdVersionHash);
        return newSet;
      }
      break;
    }
    case InsightRequestTypes.RemoveCheckedForInsightsHash: {
      if (action.dxIdVersionHash) {
        const newSet = new Set(state);
        newSet.delete(action.dxIdVersionHash);
        return newSet;
      }
      break;
    }
  }
  return state;
}

type MetricsInsightsReducerState = {
  insightDetailViewResponse: ReturnType<typeof insightDetailViewResponse>;
  metricInsights: ReturnType<typeof metricInsights>;
  checkedForInsights: Set<number>;
};

export const metricsInsightsReducer = combineReducers<MetricsInsightsReducerState>({
  insightDetailViewResponse,
  metricInsights,
  checkedForInsights,
});
